import { z } from 'zod';

const sutSchema = z.object({
  userId: z.string(),
});

export { sutSchema };
